import styled from 'styled-components';

export const Image = styled.img`
    ${({ theme }) => `
        border-radius: ${theme.shape.borderRadius}px;
    `}
    width: 100%;
    height: 100%;
    top: 0;
    position: absolute;
    object-fit: cover;
`;

export const MediaContainer = styled.div`
     ${({ theme }) => `
        margin: ${theme.spacing(2)}px;
    `}
`;

export const ImageWrapper = styled.div`
    ${({ theme }) => `
        border-radius: ${theme.shape.borderRadius}px;
    `}
    overflow: hidden;
    box-sizing: border-box;
    position: relative;
    padding-top: 100%;
`;
